<template>
  <div>
    <AppShowBannerTexts placement-name="FRONTPAGE" />
    <v-container>
      <AppShowBanners
        placement-name="FRONTPAGE"
        :show-only-position-number="4"
        large-banner
      />

      <v-row dense class="mt-5" justify="center" justify-lg="space-between">
        <v-col class="mb-2" cols="12" md="6" lg="4">
          <AppDisciplinesCard class="ma-auto">
            <template #title>
              {{ $t("calendar:disciplineBadges.Component.heading") }}
            </template>
            <template #subtitle>
              {{ $t("calendar:disciplineBadges.Component.hint") }}
            </template>
          </AppDisciplinesCard>
        </v-col>
        <v-col
          v-if="$vuetify.breakpoint.mdAndDown"
          cols="12"
          md="6"
          class="mb-2"
        >
          <AppShowBanners
            placement-name="FRONTPAGE"
            :show-only-position-number="1"
          />
        </v-col>
        <v-col class="mb-2" cols="12" md="6" lg="4">
          <AppDisciplinesCard class="ma-auto" :params="resultsCalendarParams">
            <template #title>
              {{
                $t(
                  "calendar:resultsDisciplineBadges.Component.heading",
                  "Results"
                )
              }}
            </template>
            <template #subtitle>
              {{
                $t(
                  "calendar:resultsDisciplineBadges.Component.text",
                  "Shows results of past shows"
                )
              }}
            </template>
          </AppDisciplinesCard>
        </v-col>
        <v-col
          v-if="$vuetify.breakpoint.mdAndDown"
          cols="12"
          md="6"
          class="mb-2"
        >
          <AppShowBanners
            placement-name="FRONTPAGE"
            :show-only-position-number="2"
          />
        </v-col>
        <v-col class="mb-2" cols="12" md="6" lg="4">
          <div class="fipa-card transparent-border ma-auto">
            <v-card class="fipa-card--content" style="flex-grow: 1">
              <v-card
                color="primary white--text"
                class="fipa-card--header"
                flat
              >
                <h3 class="fipa-card--header--title">
                  {{
                    $t(
                      "temporary:landingpage.howtobox.title",
                      "How to start using new KIPA?",
                      "Landing page how to section title"
                    )
                  }}
                </h3>
              </v-card>

              <article class="no-top pt-2">
                <div v-for="(support, i) in supportCardContent" :key="i">
                  <section class="px-1">
                    <div role="title" style="font-size: 15px">
                      {{ support.title }}
                    </div>

                    <small>
                      <a
                        :href="support.link"
                        class="accent--text"
                        target="_blank"
                      >
                        {{ support.linkText
                        }}<v-icon right small>$iconExternalLink</v-icon>
                      </a>
                    </small>
                  </section>
                  <hr
                    v-show="supportCardContent.length - 1 != i"
                    class="primary mb-1 mt-1"
                  />
                </div>
                <div v-if="$federation.isFinlandEquestrian">
                  <v-card-actions
                    style="
                      justify-content: flex-end;
                      position: relative;
                      left: 28px;
                    "
                    class="px-6"
                  >
                    <v-btn :to="{ name: 'Support' }" text color="primary">
                      {{
                        $t("temporary:landingpage.howtobox.findOutMore.title")
                      }}
                      <v-icon right small> $iconCircleArrowRight </v-icon>
                    </v-btn>
                  </v-card-actions>
                </div>
              </article>
            </v-card>
          </div>
        </v-col>

        <v-col v-if="$vuetify.breakpoint.lgAndUp" cols="12" class="mb-2">
          <AppShowBanners
            placement-name="FRONTPAGE"
            :overwrite-max-position="6"
            :show-only-positions="[8, 9, 10, 11, 12, 13]"
          />
        </v-col>

        <v-col
          v-if="$vuetify.breakpoint.mdAndDown"
          cols="12"
          md="6"
          class="mb-2"
        >
          <AppShowBanners
            placement-name="FRONTPAGE"
            :show-only-position-number="3"
          />
          <AppShowBanners placement-name="FRONTPAGE_RESPONSIVE" />
        </v-col>
      </v-row>
      <div v-if="$vuetify.breakpoint.lgAndUp">
        <AppShowBanners
          placement-name="FRONTPAGE"
          :show-only-positions="[1, 2, 3]"
        />
        <AppShowBanners placement-name="FRONTPAGE_RESPONSIVE" />
      </div>

      <div v-if="primaryNews.length > 0" class="my-4">
        <template v-if="newsFirstBlockHeader">
          <h2 class="mb-2">{{ newsFirstBlockHeader }}</h2>
          <v-divider />
        </template>
        <AppNewsList :news="primaryNews" />
      </div>

      <div v-if="news.length > 0" class="my-4">
        <template v-if="newsSecondBlockHeader">
          <h2 class="mb-2">{{ newsSecondBlockHeader }}</h2>
          <v-divider />
        </template>
        <AppNewsList :news="news" />
      </div>

      <div v-if="$apollo.queries.events.loading" class="my-4">
        <div class="d-flex justify-center" style="overflow: hidden">
          <v-progress-linear indeterminate color="secondary" />
        </div>
      </div>

      <template v-if="events.length > 0">
        <v-row>
          <v-col
            v-for="event in events"
            :key="event.id"
            :class="['my-3']"
            cols="12"
          >
            <EventCard :event="event" />
          </v-col>
        </v-row>
      </template>

      <AppShowBanners
        placement-name="FRONTPAGE"
        :show-only-positions="[5, 6, 7]"
      />
    </v-container>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import privacyPolicy from "@/assets/Rekisteriseloste_KIPA.pdf";

import gql from "fraql";
import i18next from "i18next";
import { getFederationConfiguration } from "@composables/masterdata/config";
import { truncate } from "lodash-es";
import sanitizeHtml from "sanitize-html";
import AppNewsList from "@elements/AppNewsList.vue";
import EventCard from "@/components/event/EventCard.vue";
import AppShowBanners from "@elements/banners/AppShowBanners.vue";
import AppShowBannerTexts from "@elements/banners/AppShowBannerTexts.vue";
import AppDisciplinesCard from "@elements/AppDisciplinesCard/index";

//import AppAlertNotice from "@/components/elements/AppAlertNotice";

export default defineComponent({
  name: "LandingPage",
  components: {
    AppNewsList,
    EventCard,
    AppShowBanners,
    AppShowBannerTexts,
    //AppAlertNotice,
    AppDisciplinesCard
  },
  setup() {
    return {
      ...getFederationConfiguration()
    };
  },
  data() {
    return {
      currentLanguage: i18next.language,
      primaryNews: [],
      news: [],
      events: [],
      calendar: false,
      newsLoading: false,
      newsAbortController: window.AbortController ? new AbortController() : null
    };
  },
  computed: {
    newsFirstBlockHeader() {
      if (i18next.exists("temporary:landingpage.news.firstBlock.title"))
        return this.$t("temporary:landingpage.news.firstBlock.title");
      else return null;
    },
    newsSecondBlockHeader() {
      if (i18next.exists("temporary:landingpage.news.secondBlock.title"))
        return this.$t("temporary:landingpage.news.secondBlock.title");
      else return null;
    },
    resultsCalendarParams() {
      return {
        eventsFrom: this.$dayjs().subtract(2, "months").format("YYYY-MM-DD"),
        eventsUntil: this.$dayjs().format("YYYY-MM-DD"),
        statusesSelected: ["results_published"],
        competitionLevelsOnlyCategoryCompetition: true,
        countryIds: []
      };
    },
    supportCardContent() {
      switch (this.$federation.countryCode) {
        case "BE": {
          const currLng = this.currentLanguage.split("-")[0];
          return [
            {
              title: this.$t(
                "temporary:landingpage.howtobox.PrivacyPolicy.title",
                "Privacy Policy"
              ),
              linkText: this.$t(
                "temporary:landingpage.howtobox.PrivacyPolicy.link",
                "Link to document"
              ),
              link: null,
              links: {
                en: "https://equibel-en.helpscoutdocs.com/article/23-privacy-statement",
                nl: "https://equibel-nl.helpscoutdocs.com/article/110-privacy-statement",
                fr: "https://equibel-fr.helpscoutdocs.com/article/215-privacy-statement"
              }
            },
            {
              title: this.$t(
                "temporary:landingpage.howtobox.LinkToVideo1.title",
                "How to join new KIPA?",
                "Landing page how to section how to join new KIPA video title"
              ),
              linkText: this.$t(
                "temporary:landingpage.howtobox.LinkToVideo1.link",
                "Link to short video",
                "Landing page how to section link to first video"
              ),
              link: null,
              links: {
                en: "https://vimeo.com/890975766/fb75c175a2",
                nl: "https://vimeo.com/890977070/b85e0babdb",
                fr: "https://vimeo.com/890974583/196251ed65"
              }
            },
            {
              title: this.$t(
                "temporary:landingpage.howtobox.LinkToVideo2.title",
                "How to pay for my horse licence?",
                "Landing page how to section how to add event video title"
              ),
              linkText: this.$t(
                "temporary:landingpage.howtobox.LinkToVideo2.link",
                "Link to video",
                "Landing page how to section link to second video"
              ),
              link: null,
              links: {
                en: "https://vimeo.com/882589696/29acce26e4",
                nl: "https://vimeo.com/882574645/b88ba33ca3",
                fr: "https://vimeo.com/882586043/b85ffc2797"
              }
            },
            {
              title: this.$t(
                "temporary:landingpage.howtobox.LinkToVideo3.title",
                "How to pay for athlete´s licence?"
              ),
              linkText: this.$t(
                "temporary:landingpage.howtobox.LinkToVideo3.link",
                "Link to video"
              ),
              link: null,
              links: {
                en: "https://vimeo.com/890982548/0736b8651a",
                nl: "https://vimeo.com/890980182/29942fe257",
                fr: "https://vimeo.com/890985009/ce2f56b816"
              }
            }
          ].map(item => {
            item.link = item.links[currLng];
            return item;
          });
        }
        case "FI":
          return [
            {
              title: this.$t(
                "temporary:landingpage.howtobox.PrivacyPolicy.title",
                "Privacy Policy"
              ),
              linkText: this.$t(
                "temporary:landingpage.howtobox.PrivacyPolicy.link",
                "Link to document"
              ),
              link: privacyPolicy
            },
            {
              title: this.$t(
                "temporary:landingpage.howtobox.LinkToVideo1.title",
                "How to join new KIPA?",
                "Landing page how to section how to join new KIPA video title"
              ),
              linkText: this.$t(
                "temporary:landingpage.howtobox.LinkToVideo1.link",
                "Link to short video",
                "Landing page how to section link to first video"
              ),
              link: "https://vimeo.com/604608338/de7039d520"
            },
            {
              title: this.$t(
                "temporary:landingpage.howtobox.LinkToVideo2.title",
                "How to pay for my horse licence?",
                "Landing page how to section how to add event video title"
              ),
              linkText: this.$t(
                "temporary:landingpage.howtobox.LinkToVideo2.link",
                "Link to video",
                "Landing page how to section link to second video"
              ),
              link: "https://vimeo.com/599464769/01e3082064"
            },
            {
              title: this.$t(
                "temporary:landingpage.howtobox.feedbackform.title",
                "Your feedback is warmly welcome!",
                "Landing page how to section feedback link title"
              ),
              linkText: this.$t(
                "temporary:landingpage.howtobox.feedbackform.link",
                "Link to feedback form",
                "Landing page how to section link to feedback form"
              ),
              link: "https://www.surveymonkey.com/r/KIPA"
            }
          ];
        case "NO":
          return [
            {
              title: this.$t("temporary:NO.landing.join.text"),
              linkText: this.$t("temporary:NO.landing.join.link"),
              link: "https://vimeo.com/594153044/1b2d0a4ba0"
            },
            {
              title: this.$t(
                "navigation:landingPage.linkTo.changeLog.label",
                "Learn about new features"
              ),
              linkText: this.$t(
                "common:genericLinkToDocument.text",
                "Link to document"
              ),
              link: "https://nryfstevne.helpscoutdocs.com/article/27-change-log"
            },
            {
              title: this.$t(
                "navigation:landingPage.linkTo.organiserWorkflow.label",
                "Workflow for organizing shows"
              ),
              linkText: this.$t(
                "common:genericLinkToDocument.text",
                "Link to document"
              ),
              link: "https://nryfstevne.helpscoutdocs.com/article/25-work-flow-for-organising-a-show-with-payments"
            },
            {
              title: this.$t("temporary:NO.landing.feedback.text"),
              linkText: this.$t("temporary:NO.landing.feedback.link"),
              link: "https://www.surveymonkey.com/r/FIPAfeedbackNO"
            }
          ];
        case "UA":
          return [
            {
              title: this.$t("temporary:UA.landing.signin.text"),
              linkText: this.$t(
                "temporary:landingpage.howtobox.LinkToVideo1.link"
              ),
              link: "https://vimeo.com/668136280/247194a50c"
            },
            {
              title: this.$t("temporary:UA.landing.howToRegister.text"),
              linkText: this.$t(
                "temporary:landingpage.howtobox.LinkToVideo1.link"
              ),
              link: "https://vimeo.com/668136117/f04ebf9372"
            }
          ];
        case "NL":
          return [
            {
              title: this.$t(
                "temporary:landingpage.howtobox.PrivacyPolicy.title",
                "Privacy Policy"
              ),
              linkText: this.$t(
                "temporary:landingpage.howtobox.PrivacyPolicy.link",
                "Link to document"
              ),
              link: null
            },
            {
              title: this.$t(
                "temporary:landingpage.howtobox.LinkToVideo1.title",
                "How to join new KIPA?",
                "Landing page how to section how to join new KIPA video title"
              ),
              linkText: this.$t(
                "temporary:landingpage.howtobox.LinkToVideo1.link",
                "Link to short video",
                "Landing page how to section link to first video"
              ),
              link: null
            },
            {
              title: this.$t(
                "temporary:landingpage.howtobox.LinkToVideo2.title",
                "How to pay for my horse licence?",
                "Landing page how to section how to add event video title"
              ),
              linkText: this.$t(
                "temporary:landingpage.howtobox.LinkToVideo2.link",
                "Link to video",
                "Landing page how to section link to second video"
              ),
              link: null
            },
            {
              title: this.$t(
                "temporary:landingpage.howtobox.feedbackform.title",
                "Your feedback is warmly welcome!",
                "Landing page how to section feedback link title"
              ),
              linkText: this.$t(
                "temporary:landingpage.howtobox.feedbackform.link",
                "Link to feedback form",
                "Landing page how to section link to feedback form"
              ),
              link: null
            }
          ];
        default:
          return [];
      }
    }
  },
  created() {
    i18next.on("languageChanged", this.setLanguage);
  },
  mounted() {
    switch (this.$federation.countryCode) {
      case "FI":
        this.getFinlandPrimaryNews();
        break;
    }
  },
  beforeDestroy() {
    this.newsAbortController?.abort();
    i18next.off("languageChanged", this.setLanguage);
  },
  apollo: {
    events: {
      query: gql`
        query landingPageHighlightedEvents($endDateFrom: String) {
          events(
            endDateFrom: $endDateFrom
            limit: 6
            sortBy: "startDate"
            isHighlighted: true
          ) {
            ${EventCard.fragments.events}
          }
        }
      `,
      variables() {
        return {
          endDateFrom: this.$dayjs().format("YYYY-MM-DD")
        };
      },
      fetchPolicy: "cache-and-network"
    },
    federationConfiguration: {
      query: gql`
        query frontpageRssFeed {
          federationConfiguration {
            frontpageRssFeed
          }
        }
      `,
      fetchPolicy: "cache-first",
      result({ loading, data }) {
        if (loading || !data?.federationConfiguration?.frontpageRssFeed) return;
        this.newsLoading = true;
        fetch(
          "https://api.rss2json.com/v1/api.json?rss_url=" +
            data.federationConfiguration.frontpageRssFeed,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json"
            },
            signal: this.newsAbortController?.signal
          }
        )
          .then(x => x.json())
          .then(response => {
            if (response.items?.length > 0) {
              this.news = response.items.map(news => {
                news.description = truncate(
                  sanitizeHtml(news.description, {
                    allowedAttributes: {
                      a: ["href"]
                    }
                  }),
                  {
                    length: 280
                  }
                );
                return news;
              });
            }

            this.newsLoading = false;
          })
          .catch(error => {
            this.$sentryThrowError.throwError(error, {
              level: "warning",
              additionalDetails: {
                from: "LandingPage - federationConfiguration"
              }
            });
            this.newsLoading = false;
          });
      }
    }
  },
  methods: {
    setLanguage(lng) {
      this.currentLanguage = lng;
    },
    getFinlandPrimaryNews() {
      fetch(
        "https://api.rss2json.com/v1/api.json?rss_url=" +
          "https://www.ratsastus.fi/tiedotteet/rss/",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          },
          signal: this.newsAbortController?.signal
        }
      )
        .then(x => x.json())
        .then(({ items }) => {
          this.primaryNews = items.map(news => {
            news.description = truncate(
              sanitizeHtml(news.description, {
                allowedAttributes: {
                  a: ["href"]
                }
              }),
              {
                length: 280
              }
            );
            return news;
          });
        })
        .catch(error => {
          this.$sentryThrowError.throwError(error, {
            level: "warning",
            additionalDetails: { from: "LandingPage - mounted()" }
          });
          this.primaryNews = [];
        });
    }
  }
});
</script>
<style lang="scss">
.event-vertical-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: initial !important;
  &--content {
    height: 100%;
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
  margin-left: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.card-content {
  position: relative;
  display: flex;
  flex-direction: column;
  color: black;
  height: 100%;
}
.card-header {
  border-radius: 4px 4px 0 0 !important;
  height: 80px;
}
.card-title {
  font-size: 20px;
  color: white;
  margin: auto;
  height: 80px;
  display: flex;
  align-items: center;
}
</style>
